module.exports = __webpack_public_path__ + "media/Punktebild_35.99455620.mp4";